// Home.js
import { useNavigate } from "react-router-dom";
import Productpage from "./Dashboard/Productpage";
import HeroSection from "./HeroSection"; // ⬅️ new import

export default function Home() {
  const navigate = useNavigate();

  const features = [
    {
      icon: "👍",
      title: "Seamless Barter System",
      description:
        "Easily swap your items with others in a simple and user-friendly platform. Find what you need and trade what you have—no cash required.",
    },
    {
      icon: "🚚",
      title: "Diverse Marketplace",
      description:
        "From books to jewelry, Swapiify offers a wide range of items to trade. Connect with others and find exactly what you're looking for.",
    },
    {
      icon: "🛡️",
      title: "Sustainable Trading",
      description:
        "Trade your clothes, toys, bags, and more while promoting sustainability. Give your items a second life with just a few clicks.",
    },
  ];

  const howItWorks = [
    {
      step: "1",
      title: "Create Your Profile",
      description:
        "Sign up, add details about yourself, and set your trading preferences.",
    },
    {
      step: "2",
      title: "List Your Items",
      description:
        "Upload pictures, describe what you're offering, and mention what you're looking for in return.",
    },
    {
      step: "3",
      title: "Explore & Find Matches",
      description:
        "Browse thousands of listings across different categories. Use filters to find the perfect trade.",
    },
    {
      step: "4",
      title: "Make & Receive Offers",
      description:
        "Negotiate directly with other users by sending and receiving trade requests.",
    },
    {
      step: "5",
      title: "Swap & Enjoy!",
      description:
        "Finalize the deal, arrange the exchange, and enjoy your newly swapped item.",
    },
  ];

  const icons = ["👤", "📋", "🔍", "💬", "🤝"];

  // ✅ Category image tiles for the “Trade, Swap & Refresh” section
  const browseCategories = [
    {
      key: "Toys & Games",
      label: "TOYS & GAMES",
      image:
        "https://demo.swapiify.com/uploads/products/Early_Years_toys_630_465_int_s_c1.png",
    },
    {
      key: "Sporting Goods",
      label: "SPORTING GOODS",
      image:
        "https://images.pexels.com/photos/47730/the-ball-stadion-football-the-pitch-47730.jpeg?auto=compress&cs=tinysrgb&w=1200",
    },
    {
      key: "Accessories",
      label: "ACCESSORIES",
      image: "https://demo.swapiify.com/uploads/products/shopping.webp",
    },
    {
      key: "Clothes",
      label: "CLOTHES",
      image:
        "https://images.pexels.com/photos/291762/pexels-photo-291762.jpeg?auto=compress&cs=tinysrgb&w=1200",
    },
    {
      key: "Books",
      label: "BOOKS",
      image:
        "https://demo.swapiify.com/uploads/products/21%20Books%20on%20Our%20Shelves%20for%20Personal%20and%20Professional%20Development.webp",
    },
    {
      key: "Bags",
      label: "BAGS",
      image:
        "https://demo.swapiify.com/uploads/products/71izkVh7BML._AC_UY1100_.jpg",
    },
  ];

  // ✅ Go to products page WITH category filter
  const handleCategoryClick = (categoryKey) => {
    navigate(`/products?category=${encodeURIComponent(categoryKey)}`);
    window.scrollTo(0, 0);
  };

  return (
    <>
      {/* Global font import for titles */}
      <style>
        {`
          @import url('https://fonts.googleapis.com/css2?family=Poppins:wght@600;700;800&display=swap');
        `}
      </style>

      <div style={styles.container}>
        {/* Hero Section */}
        <HeroSection />

        {/* ✅ COMBINED Welcome + Features Section (single orange block) */}
        <section style={styles.welcomeSection}>
          <div style={styles.sectionContainer}>
            <h2 style={styles.sectionTitle}>Welcome to Swapiify!</h2>
            <p style={styles.welcomeText}>
              <strong>Why buy when you can swap?</strong> Swapiify lets you
              trade what you don't need for what you actually want—zero cash,
              zero waste, all value. List your items, discover matches, and
              make the perfect trade. Start swapping today and be part of the
              future of smart, sustainable trading!
            </p>

            {/* ⭐ Features now inside SAME section */}
            <div style={styles.featuresGrid}>
              {features.map((feature, index) => (
                <div key={index} style={styles.featureCard}>
                  <div style={styles.featureIconWrapper}>
                    <span style={styles.featureIcon}>{feature.icon}</span>
                  </div>
                  <div style={styles.featureTextWrapper}>
                    <h3 style={styles.featureTitle}>{feature.title}</h3>
                    <p style={styles.featureDescription}>
                      {feature.description}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* ✅ Trade, Swap & Refresh – category image grid */}
        <section style={styles.browseSection}>
          <div style={styles.sectionContainer}>
            <h2 style={styles.browseTitle}>Trade, Swap & Refresh: Browse Items</h2>

            <div style={styles.browseGrid}>
              {browseCategories.map((cat) => (
                <div
                  key={cat.key}
                  style={styles.browseCard}
                  onClick={() => handleCategoryClick(cat.key)}
                >
                  <div style={styles.browseImageWrapper}>
                    <img
                      src={cat.image}
                      alt={cat.label}
                      style={styles.browseImage}
                    />
                    <div style={styles.browseLabelWrapper}>
                      <span style={styles.browseLabel}>{cat.label}</span>
                    </div>
                  </div>
                </div>
              ))}
            </div>

        {/* View All button → Categories page */}
        <div style={{ textAlign: "center", marginTop: "40px" }}>
          <button
            onClick={() => navigate("/Categories")}
            className="btn"
            style={{
              padding: "10px 22px",
              borderRadius: 8,
              border: "none",
              backgroundColor: "#FF7F50",
              color: "#fff",
              cursor: "pointer",
              fontWeight: "600",
              fontSize: 15,
              marginTop: 20
            }}
          >
            View All →
          </button>
        </div>

          </div>
        </section>

        {/* Marketplace Section */}
        <Productpage limit={8} showAllOpensPage={true} />

        {/* How It Works Section */}
        <section style={styles.howItWorksSectionPremium}>
          <div style={styles.sectionContainer}>
            <h2 style={styles.howTitle}>How Swapiify Works?</h2>

            <div style={styles.howGrid}>
              {howItWorks.map((step, index) => (
                <div key={index} style={styles.howCard}>
                  <div style={styles.howIcon}>{icons[index]}</div>

                  <h3 style={styles.howStepTitle}>
                    Step {step.step}: {step.title}
                  </h3>

                  <p style={styles.howStepDesc}>{step.description}</p>
                </div>
              ))}
            </div>
          </div>
        </section>
      </div>
    </>
  );
}

const styles = {
  container: {
    fontFamily: "Arial, sans-serif",
    lineHeight: 1.6,
  },

  // Common Section Styles
  sectionContainer: {
    maxWidth: "1650px",
    margin: "0 auto",
    padding: "0 20px",
  },
  sectionTitle: {
    fontSize: "2.5rem",
    textAlign: "center",
    marginBottom: "30px",
    color: "#702963",
    fontWeight: "700",
    fontFamily: "'Poppins', sans-serif",
  },

  // ✅ Combined Welcome + Features Section
  welcomeSection: {
    padding: "60px 0 70px",
    backgroundColor: "#FF7F50",
  },
  welcomeText: {
    fontSize: "1.2rem",
    textAlign: "center",
    maxWidth: "800px",
    margin: "0 auto 40px",
    color: "#fff",
    lineHeight: 1.8,
  },

  // Features grid inside same section
  featuresSection: {
    // ❌ no longer used (but kept if needed later)
  },
  featuresGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(3, 1fr)",
    gap: "40px",
    maxWidth: "1300px",
    margin: "0 auto",
    alignItems: "flex-start",
  },
  featureCard: {
    display: "flex",
    alignItems: "flex-start",
    gap: "18px",
  },
  featureIconWrapper: {
    width: "52px",
    height: "52px",
    borderRadius: "50%",
    border: "2px solid #702963",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexShrink: 0,
    backgroundColor: "transparent",
  },
  featureIcon: {
    fontSize: "22px",
    color: "#702963",
  },
  featureTextWrapper: {
    textAlign: "left",
  },
  featureTitle: {
    fontSize: "1.4rem",
    marginBottom: "10px",
    color: "#702963",
    fontWeight: "700",
    fontFamily: "'Poppins', sans-serif",
  },
  featureDescription: {
    color: "#fff",
    lineHeight: 1.7,
    fontSize: "0.98rem",
  },

  // ✅ Browse Categories (image grid) styles
  browseSection: {
    padding: "100px 0 100px",
    backgroundColor: "#ffeee7",
  },
  browseTitle: {
    fontSize: "2rem",
    textAlign: "center",
    marginBottom: "40px",
    color: "#ff7f50",
    fontWeight: "800",
    fontFamily: "'Poppins', sans-serif",
  },
  browseGrid: {
    display: "grid",
    maxWidth: "1300px",
    margin: "auto",
    gridTemplateColumns: "repeat(3, 1fr)",
    gap: "20px",
  },
  browseCard: {
    cursor: "pointer",
  },
  browseImageWrapper: {
    position: "relative",
    overflow: "hidden",
    borderRadius: "0px",
    boxShadow: "0 10px 25px rgba(0,0,0,0.1)",
  },
  browseImage: {
    display: "block",
    width: "100%",
    height: "400px",
    objectFit: "cover",
    transition: "transform 0.4s ease",
  },
  browseLabelWrapper: {
    position: "absolute",
    left: "18px",
    bottom: "18px",
    backgroundColor: "#ffffff",
    padding: "10px 18px",
    boxShadow: "0 6px 18px rgba(0,0,0,0.18)",
  },
  browseLabel: {
    fontSize: "0.9rem",
    fontWeight: "700",
    letterSpacing: "0.08em",
    color: "#111",
  },

  // How Swapiify Works?
  howItWorksSectionPremium: {
    padding: "70px 0 90px",
    backgroundColor: "#ffffffff ",
  },
  howTitle: {
    fontSize: "2.0rem",
    textAlign: "center",
    marginBottom: "40px",
    color: "#702963",
    fontWeight: "800",
    fontFamily: "'Poppins', sans-serif",
  },
  howGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(5, 1fr)",
    gap: "20px",
    maxWidth: "1500px",
    margin: "0 auto",
  },
  howCard: {
    backgroundColor: "#ccaac6",
    borderRadius: "18px",
    padding: "35px 25px",
    textAlign: "center",
    minHeight: "240px",
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    alignItems: "center",
    boxShadow: "0 8px 20px rgba(0,0,0,0.05)",
  },
  howIcon: {
    fontSize: "38px",
    color: "#702963",
    marginBottom: "18px",
  },
  howStepTitle: {
    fontSize: "1.05rem",
    fontWeight: "700",
    color: "#ffffffff",
    marginBottom: "12px",
    fontFamily: "'Poppins', sans-serif",
  },
  howStepDesc: {
    fontSize: "1rem",
    color: "#ffffffff",
    maxWidth: "235px",
    margin: "auto",
    opacity: 0.95,
    lineHeight: 1.55,
    margin: 0,
  },
};
